import React from 'react';
import { Header, Table } from 'semantic-ui-react';


export default function JobTable(props) {
  // Sort and filter jobs and show them in the table.

  const statusTranslations = {
    'pending': 'Odottaa',
    'started': 'Käynnissä',
    'finished': 'Valmis',
    'failed': 'Epäonnistui'
  }

  return (
    <React.Fragment>
      <Header as='h3'>Työjono</Header>
      <p>Taulukko näyttää edelliset 20 prosessiajoa viimeisen vuoden ajalta.</p>
      {props.jobs.length > 0 ? (
        <Table celled striped unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Taso</Table.HeaderCell>
              <Table.HeaderCell>Tila</Table.HeaderCell>
              <Table.HeaderCell>Viimeksi päivitetty</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.jobs.map(job => (
              <Table.Row key={job.id} positive={job.status === 'finished'} negative={job.status === 'failed'}>
                <Table.Cell>{job.input.name}</Table.Cell>
                <Table.Cell>{statusTranslations[job.status]}</Table.Cell>
                <Table.Cell>{new Date(job.updated).toLocaleString('fi-FI')}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ) : (<p>Ei tietoja.</p>)
      }
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/main/JobTable.js